const WebsiteDevelopment  = {
    "heroQuoteSection": {
        "enable": true,
        "title": "WEB DEVELOPMENT",
        "headline": "<strong>rooted in technology and engineering,</strong> weʼre hard-wired to prototype, build and deliver.",
        "image": require('../images/web-dev/web-dev.png'),
        "position": "center", //center, left or rightM
        "btnGrad" : "yellow",
        "class": "move-from-left"
    },
    "textWithImage":{
      "enable": true,
      "content": "Mobikasa has been rated amongst New York’s top web development companies.",
      "image": require('../images/web-dev/placeholder.png'),
      "position": "right", //center, left or rightM
      "class": "slider-right",
      "slider": {
        "type": 1,
        "images": [
          {
            "laptop": require('../images/web-dev/slide1.png'),
            "mobile": require('../images/web-dev/slide1-m.png'),
            "alt": "Beauty Rx"
          },
          {
            "laptop": require('../images/web-dev/slide2.png'),
            "mobile": require('../images/web-dev/slide2-m.png'),
            "alt": "Maurice"
          },
          {
            "laptop": require('../images/web-dev/slide3.png'),
            "mobile": require('../images/web-dev/slide3-m.png'),
            "alt": "Holland & Sherry"
          }
        ]
      }
    },
    "headingWithIcons":{
      "enable": true,
      "title": "We are experts in",
      "columns": 4, //value should be 4 or 6
      "icons": [
        {
          "src": require('../svgs/magento.svg'),
          "alt": "Magento"
        },
        {
          "src": require('../svgs/shopify.svg'),
          "alt": "Shopify"
        },{
          "src": require('../svgs/wordpress.svg'),
          "alt": "Wordpress"
        },
        {
          "src": require('../svgs/rubyrail.svg'),
          "alt": "Rails"
        },
        {
          "src": require('../svgs/google-cloud.svg'),
          "alt": "Google Cloud"
        },
        {
          "src": require('../svgs/node-js.svg'),
          "alt": "Node Js"
        },
        {
          "src": require('../svgs/amazon_web_services.svg'),
          "alt": "Amazon Web Services"
        },        
        {
          "src": require('../svgs/net.svg'),
          "alt": "Microsoft ASP.net"
        },
        {
          "src": require('../svgs/html.svg'),
          "alt": "HTML5"
        },
        {
          "src": require('../svgs/salesforce.svg'),
          "alt": "Salesforce"
        },
        {
          "src": require('../svgs/php.svg'),
          "alt": "PHP"
        },
        {
          "src": require('../svgs/sitecore.svg'),
          "alt": "Sitecore"
        }      
      ]
    },
    "faq":{
      "enable": true,
      "title": "Frequently asked questions",
      "questions": [
        {
          "key": 1,
          "q": "What kind of web development services are offered?",
          "a": "Web development services range from front and back end development, e-commerce development, web app development, third party integrations and customizations, prototyping and UXD all the way to technical consultancy. The list is nearly endless. However, all of the previously stated services are worked on different platforms used for web design."
        },
        {
          "key": 2,
          "q": "What are the benefits of hiring a web development company?",
          "a": `Now of-course any business or brand can have their website developed in house. However, this in house development comes with a lot of issues. Listed below are the reasons why a professional web development agency should be hired for web development as opposed to having it all done in house.
          <br /><br />
          <ul class="default">
          <li><strong>Time Saving</strong> – In-house web development is a time-consuming process that requires setting up a team/ hiring a freelancer, making and learning from mistakes made in the design process. A web development company already has the expertise in place and has set procedures that help get work done efficiently and to a certain standard. Which is why hiring a professional will save you a lot of precious time.</li><br />
          <li><strong>Search Engine Optimization (SEO) Friendly</strong> – A web development agency knows the importance of SEO in the e-commerce segment which is why they create websites that can help your brand rank ahead of your competition.Learn more about SEO here.</li><br />
          <li><strong>Browser Compatibility</strong> – Browser compatibility talks about having a website that works perfectly on more than one web browser. A professional web development agency can develop a website that works on all search engines, be it yahoo, google, firefox or bing.</li><br />
          <li><strong>Quality always wins</strong> – If you wish to stay competitive, you must posses the very best. A web design company can help you build a website that is attractive, quick to load, technically sound and engaging to the users. This is what helps online brands stay competitive.</li>
          </ul>`
        },
        {
          "key": 3,
          "q": "Which platform is best for web development?",
          "a": "Each platform has its own pros and cons. What’s best, depends on what your brand is looking for. Some platforms support more flamboyant designs while others are more suitable for content-based websites. Here at Mobikasa, we communicate with our clients to figure out exactly what they are looking for and what would work best for them. Our team of professionals possess expertise on all platforms, thus enabling us to find the best web development solution for our clients."
        }
      ]
    }
  };

  export default WebsiteDevelopment;